
export class UserGroup {

  constructor(public id: string,
              public eventId: string,
              public unread: number = 0,
              public status: number = 0) {

  }

  static fromAngularFireSnapshots(snapshots: any) : UserGroup[] {
    return snapshots.map(snap => UserGroup.fromSnapshot(snap.key, snap.payload.val()));
  }

  static fromSnapshot(key: string, {status, unread, eventId}) {
    return new UserGroup(key, eventId, unread, status);
  }


}



// WEBPACK FOOTER //
// ./src/providers/communication/models/UserGroup.ts